import { asPdfBoolean, asPdfObject, toPdfColor, toPdfNumber, toPdfText } from '../safeValues';

/**
 * Template 3 cover page settings (configs.cover), edited in the "Cover Page" section of the
 * template editor. Templates saved before the section existed have no `cover` key, so every
 * field falls back to these defaults - the cover then looks exactly as it always did.
 */
export const TEMPLATE_THREE_COVER_DEFAULTS = {
  show: true,
  label: 'QUOTATION',
  bandColor: '', // empty = the PDF theme color
  showTitle: true,
  titleSize: 27,
  titleColor: '', // empty = white
  showReference: true,
  showPartyCards: true,
  preparedForBackground: '#ffffff',
  preparedByBackground: '#f1f3f7',
  showBranch: true, // the quotation's branch line in the Prepared By card
  showSalesAgent: true, // the quotation's sales agent line in the Prepared By card
  showValidityStrip: true,
  showSignatory: true,
  showFooterContacts: true,
  greeting: 'Dear Sir / Madam,',
  message: 'Thank you for your request. Please find our detailed quotation on the following page.'
};

/** Cover title color when none is chosen (configs.cover.titleColor is empty). */
export const COVER_TITLE_DEFAULT_COLOR = '#ffffff';

/** Allowed cover title font size (pt) - the editor slider uses the same range. */
export const TITLE_SIZE_RANGE = { min: 16, max: 40 };

const text = (value, fallback) => {
  const safe = toPdfText(value).trim();
  return safe || fallback;
};

export const resolveCoverConfig = (rawCover) => {
  const cover = asPdfObject(rawCover);
  const defaults = TEMPLATE_THREE_COVER_DEFAULTS;

  return {
    show: asPdfBoolean(cover.show, defaults.show),
    label: text(cover.label, defaults.label),
    bandColor: toPdfText(cover.bandColor).trim(),
    showTitle: asPdfBoolean(cover.showTitle, defaults.showTitle),
    titleSize: toPdfNumber(cover.titleSize, defaults.titleSize, { min: TITLE_SIZE_RANGE.min, max: TITLE_SIZE_RANGE.max }),
    titleColor: toPdfText(cover.titleColor).trim(),
    showReference: asPdfBoolean(cover.showReference, defaults.showReference),
    showPartyCards: asPdfBoolean(cover.showPartyCards, defaults.showPartyCards),
    preparedForBackground: toPdfColor(cover.preparedForBackground, defaults.preparedForBackground),
    preparedByBackground: toPdfColor(cover.preparedByBackground, defaults.preparedByBackground),
    showBranch: asPdfBoolean(cover.showBranch, defaults.showBranch),
    showSalesAgent: asPdfBoolean(cover.showSalesAgent, defaults.showSalesAgent),
    showValidityStrip: asPdfBoolean(cover.showValidityStrip, defaults.showValidityStrip),
    showSignatory: asPdfBoolean(cover.showSignatory, defaults.showSignatory),
    showFooterContacts: asPdfBoolean(cover.showFooterContacts, defaults.showFooterContacts),
    // greeting / message may be cleared on purpose : only a missing key falls back
    greeting: cover.greeting === undefined ? defaults.greeting : toPdfText(cover.greeting).trim(),
    message: cover.message === undefined ? defaults.message : toPdfText(cover.message).trim()
  };
};
